/* ==========================================================================
   MADE TO ORDER - inline on the product page - J & A Doors - Codelabs
   Upload as: assets/mtp.js

   No popup. Size inputs + hinge options sit in the product form. Price updates
   live using the same engine: next size up that covers both dimensions, +50%
   if one dimension is custom, +100% if both, exact stock size = no markup.
   Markup + hinge ride as a 1p charge product (quantity = exact pence) so the
   basket reconciles to the penny (storefront can't set custom line prices).

   v2: the charge line now carries EVERYTHING above the door variant's own
   price. In the gap case the door variant is a smaller stand-in whose price is
   below the quoted base, so the basket used to undercharge by the difference.

   v3: works on products with a colour option as well as a size one. The size
   is read from the option that holds sizes rather than the variant title, and
   the engine prices from the selected colour only, following colour changes.

   v4: the orderable range is now set per range in mtp.liquid instead of being
   inferred from the size grid. Ora is made up to 2540 x 1200 but its biggest
   stock size is 1245 x 596, so every panel above the grid used to be turned
   away with "contact us". Sizes beyond the grid are now extrapolated by area
   from the largest stock size and flagged as estimated.
   ========================================================================== */
(function () {
  'use strict';
  var ROOTS = document.querySelectorAll('[data-mtp-root]');
  for (var i = 0; i < ROOTS.length; i++) init(ROOTS[i]);

  function init(ROOT) {
    if (ROOT.dataset.ready === '1') return;
    ROOT.dataset.ready = '1';

    var UID = ROOT.getAttribute('data-instance');
    var CFGEL = ROOT.querySelector('[data-mtp-cfg]');
    var PRODEL = ROOT.querySelector('[data-mtp-product]');
    if (!CFGEL || !PRODEL) return;

    var CFG, PRODUCT;
    try { CFG = JSON.parse(CFGEL.textContent); PRODUCT = JSON.parse(PRODEL.textContent); }
    catch (e) { return; }
    var base = (CFG.root || '/').replace(/\/$/, '');

    var $ = function (s) { return ROOT.querySelector(s); };
    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
        .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }
    var MONEY_RE = /\{\{\s*(\w+)\s*\}\}/;
    function grp(c,p,t,d){ if(isNaN(c)||c===null)return'0'; var n=(c/100).toFixed(p),a=n.split('.');
      return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+t)+(a[1]?d+a[1]:''); }
    function money(c){
      var f=CFG.moneyFormat||'',m=f.match(MONEY_RE); if(!m)return grp(c,2,',','.');
      var v; switch(m[1]){
        case'amount_no_decimals':v=grp(c,0,',','.');break;
        case'amount_with_comma_separator':v=grp(c,2,'.',',');break;
        case'amount_no_decimals_with_comma_separator':v=grp(c,0,'.',',');break;
        case'amount_with_apostrophe_separator':v=grp(c,2,"'",'.');break;
        case'amount_with_space_separator':v=grp(c,2,' ',',');break;
        case'amount_no_decimals_with_space_separator':v=grp(c,0,' ',',');break;
        case'amount_with_period_and_space_separator':v=grp(c,2,' ','.');break;
        default:v=grp(c,2,',','.');
      } return f.replace(MONEY_RE,v);
    }
    function fmt(n){ return String(Math.round(n*100)/100); }

    /* ===== engine =====
       Size titles carry suffixes on this store, e.g. "570 x 296 (M2M)". Those
       are real purchasable sizes and must count. Accessories like
       "110 x 596 SQ Panel", "Plinth 150H x 18T x 2700L" or
       "800H x 350W Edged End Panel" must not. So we allow trailing
       parenthetical tags only, never bare words. ===== */
    var SIZE_RE = /^\s*(\d+(?:\.\d+)?)\s*[HhWw]?\s*[x\u00d7X]\s*(\d+(?:\.\d+)?)\s*[HhWw]?\s*(?:mm)?\s*(?:\([^)]*\)\s*)*$/i;
    function parseSize(s) {
      var m = String(s == null ? '' : s).match(SIZE_RE);
      return m ? { h: parseFloat(m[1]), w: parseFloat(m[2]) } : null;
    }

    /* ===== variant index =====
       On a single option product the variant title IS the size ("715 x 596").
       Where the range also has a colour option the title reads
       "Supermatt Alabaster / 715 x 396", which no longer parses. So read the
       size from whichever option actually holds sizes, and price only from the
       variants sharing the colour the customer has selected: the door we add to
       the basket has to be the colour they are looking at. */
    var OPTC = (PRODUCT.options && PRODUCT.options.length) || 1;
    function optVals(v) {
      if (v.options && v.options.length) return v.options;
      var a = [];
      if (v.option1 != null) a.push(v.option1);
      if (v.option2 != null) a.push(v.option2);
      if (v.option3 != null) a.push(v.option3);
      return a.length ? a : [v.title];
    }
    var SIZE_IDX = -1, bestHits = 0;
    for (var oi = 0; oi < OPTC; oi++) {
      var hits = 0;
      for (var vi = 0; vi < PRODUCT.variants.length; vi++) {
        if (parseSize(optVals(PRODUCT.variants[vi])[oi])) hits++;
      }
      if (hits > bestHits) { bestHits = hits; SIZE_IDX = oi; }
    }

    // every sized variant, tagged with its other option values (the colour)
    var CATALOG = [], VGROUP = {};
    PRODUCT.variants.forEach(function (v) {
      var vals = optVals(v);
      var sz = (SIZE_IDX > -1) ? parseSize(vals[SIZE_IDX]) : null;
      if (!sz) sz = parseSize(v.title);
      if (!sz) return;
      var group = vals.filter(function (x, i) { return i !== SIZE_IDX; }).join(' / ');
      CATALOG.push({ h: sz.h, w: sz.w, price: v.price, id: v.id, title: v.title, group: group });
      VGROUP[String(v.id)] = group;
    });
    if (!CATALOG.length) { ROOT.hidden = true; return; }

    /* The engine works on one colour at a time.

       Two different ceilings matter here and they are NOT the same thing:

         gridMaxH / gridMaxW  the biggest size we actually stock. Used to pick a
                              reference variant to price from.
         MAX_H / MAX_W        the biggest size the workshop will CUT. Set per
                              range in mtp.liquid. Ora cuts to 2540 x 1200 from
                              a grid that stops at 1245 x 596.

       Before v4 there was only the grid ceiling, so anything the workshop could
       make but did not stock was refused. Same story at the bottom: MIN_H /
       MIN_W are what we will cut down to, not the smallest size we stock. */
    var sized = [], stockH = {}, stockW = {}, byhw = {};
    var gridMaxH = 0, gridMaxW = 0, MIN_H = 0, MIN_W = 0, MAX_H = 0, MAX_W = 0, biggest = null;

    function buildIndex(group) {
      sized = CATALOG.filter(function (o) { return o.group === group; });
      stockH = {}; stockW = {}; byhw = {}; gridMaxH = 0; gridMaxW = 0; biggest = null;
      sized.forEach(function (o) {
        stockH[o.h] = 1; stockW[o.w] = 1; byhw[o.h + 'x' + o.w] = o;
        if (o.h > gridMaxH) gridMaxH = o.h;
        if (o.w > gridMaxW) gridMaxW = o.w;
        if (!biggest || (o.h * o.w) > (biggest.h * biggest.w)) biggest = o;
      });
      var hs = Object.keys(stockH).map(Number), ws = Object.keys(stockW).map(Number);
      MIN_H = (CFG.minH > 0) ? CFG.minH : (hs.length ? Math.min.apply(null, hs) : 0);
      MIN_W = (CFG.minW > 0) ? CFG.minW : (ws.length ? Math.min.apply(null, ws) : 0);
      MAX_H = (CFG.maxH > 0) ? CFG.maxH : gridMaxH;
      MAX_W = (CFG.maxW > 0) ? CFG.maxW : gridMaxW;
      // a configured ceiling below the grid would make stock sizes unquotable
      if (MAX_H < gridMaxH) MAX_H = gridMaxH;
      if (MAX_W < gridMaxW) MAX_W = gridMaxW;
    }

    // which colour is on screen: the theme keeps the chosen variant id in the
    // product form, so read that, then the URL, then fall back to the first
    function selectedGroup() {
      var forms = [], own = ROOT.closest('form[action*="/cart/add"]');
      if (own) forms.push(own);
      var sec = ROOT.closest('[id^="shopify-section-"], .shopify-section, section, main');
      if (sec) Array.prototype.push.apply(forms, sec.querySelectorAll('form[action*="/cart/add"]'));
      Array.prototype.push.apply(forms, document.querySelectorAll('form[action*="/cart/add"]'));
      for (var i = 0; i < forms.length; i++) {
        var inp = forms[i].querySelector('[name="id"]');
        var g = inp && VGROUP[String(inp.value)];
        if (g != null) return g;
      }
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      if (m && VGROUP[m[1]] != null) return VGROUP[m[1]];
      return CATALOG[0].group;
    }

    // Cheapest stock blank that covers BOTH measurements. Price is what the
    // customer pays and what the workshop buys, so cost is the right yardstick.
    // Ties break to the least wasted material, i.e. the closest fit.
    function cover(h, w) {
      var best = null, bestWaste = Infinity;
      for (var i = 0; i < sized.length; i++) {
        var o = sized[i];
        if (o.h < h || o.w < w) continue;
        var waste = (o.h - h) + (o.w - w);
        if (!best || o.price < best.price || (o.price === best.price && waste < bestWaste)) {
          best = o; bestWaste = waste;
        }
      }
      return best;
    }

    /* Next stock line at or above a value. Past the top of the grid there is no
       next line, so the measurement stands as its own. quote() has already
       checked it against MAX, so this can only run on a size we will cut. */
    function nextUp(map, v) {
      var ups = Object.keys(map).map(Number).filter(function (x) { return x >= v; });
      return ups.length ? Math.min.apply(null, ups) : v;
    }

    /* Gap case: no single variant covers BOTH measurements. Two shapes of it.

       Inside the grid, e.g. 900 high x 700 wide where 700+ widths only exist on
       short doors: price the next size up per axis and scale the closest real
       variant by area.

       Beyond the grid, e.g. Ora at 2000 x 900: scale the LARGEST stock size by
       area. Using the closest-by-area variant there would pick something
       arbitrary and small, and small doors carry a much higher rate per mm2
       because of fixed cutting and edging cost, so it would badly overprice.

       variantPrice is what the stand-in door variant itself costs in the
       basket. The charge line makes up the rest. */
    function gapBase(h, w) {
      var nh = nextUp(stockH, h), nw = nextUp(stockW, w);
      if (nh === null || nw === null) return null;
      var exact = byhw[nh + 'x' + nw];
      if (exact) return { price: exact.price, h: nh, w: nw, id: exact.id, variantPrice: exact.price, est: false };

      var ref = null;
      var beyondGrid = (nh > gridMaxH) || (nw > gridMaxW);
      if (beyondGrid) {
        ref = biggest;
      } else {
        // widest real variant at that height, else the closest by area
        var sameH = sized.filter(function (o) { return o.h === nh; });
        if (sameH.length) {
          ref = sameH.reduce(function (a, b) { return b.w > a.w ? b : a; });
        } else {
          var target = nh * nw;
          ref = sized.reduce(function (a, b) {
            return Math.abs(b.h * b.w - target) < Math.abs(a.h * a.w - target) ? b : a;
          });
        }
      }
      if (!ref) return null;
      var scale = (nh * nw) / (ref.h * ref.w);
      if (!isFinite(scale) || scale <= 0) return null;
      // never quote below the stand-in door we actually put in the basket
      var p = Math.max(ref.price, Math.round(ref.price * scale));
      return { price: p, h: nh, w: nw, id: ref.id, variantPrice: ref.price, est: true };
    }

    function quote(h, w) {
      if (!(h > 0) || !(w > 0)) return null;
      var ex = byhw[h + 'x' + w];
      if (ex) return { price: ex.price, doorPrice: ex.price, markupFee: 0, markPct: 0, base: ex, variantId: ex.id, kind: 'stock', custom: 0 };

      // beyond what the workshop will cut, not merely beyond what we stock
      if (h > MAX_H || w > MAX_W) return { over: true };

      var hC = !stockH[h], wC = !stockW[w];
      var n = (hC ? 1 : 0) + (wC ? 1 : 0);
      var pct = n >= 2 ? CFG.markBoth : (n === 1 ? CFG.markOne : 0);

      var b = cover(h, w), est = false, baseH, baseW, basePrice, vid, vPrice;
      if (b) { basePrice = b.price; baseH = b.h; baseW = b.w; vid = b.id; vPrice = b.price; }
      else {
        var g = gapBase(h, w);
        if (!g) return { over: true };
        basePrice = g.price; baseH = g.h; baseW = g.w; vid = g.id; est = g.est; vPrice = g.variantPrice;
      }
      var f = Math.round(basePrice * pct);
      var price = basePrice + f;
      return {
        price: price, doorPrice: vPrice,
        // everything above the door variant's own price rides on the charge
        // line, so the basket always equals the quote shown on the page
        markupFee: Math.max(0, price - vPrice), markPct: pct * 100,
        base: { h: baseH, w: baseW, price: basePrice }, variantId: vid,
        kind: 'custom', custom: n, est: est
      };
    }

    /* ===== state ===== */
    var dimH = '', dimW = '', qty = 1, confirmed = false;
    // hinge drilling, trade style: hung direction + two offsets + handle position
    var hinge = { on: false, hung: '', a: '', b: '', handle: '' };
    function blankHinge() { return { on: false, hung: '', a: '', b: '', handle: '' }; }

    /* ===== events ===== */
    ROOT.addEventListener('input', function (e) {
      if (e.target.matches('[data-dim-h]')) { dimH = e.target.value; render(); }
      else if (e.target.matches('[data-dim-w]')) { dimW = e.target.value; render(); }
      else if (e.target.matches('[data-off-a]')) { hinge.a = e.target.value; render(); }
      else if (e.target.matches('[data-off-b]')) { hinge.b = e.target.value; render(); }
      else if (e.target.matches('[data-qty-in]')) { var v = parseInt(e.target.value,10); qty = (!v||v<1)?1:v; render(); }
    });
    ROOT.addEventListener('change', function (e) {
      if (e.target.matches('[data-hinge-on]')) {
        var on = e.target.checked;
        hinge = blankHinge(); hinge.on = on;
        render(); return;
      }
      if (e.target.matches('[data-hung]')) { hinge.hung = e.target.value; hinge.a = ''; hinge.b = ''; render(); return; }
      if (e.target.matches('[data-handle]')) { hinge.handle = e.target.value; render(); return; }
      if (e.target.matches('[data-confirm]')) { confirmed = e.target.checked; syncBtn(); }
    });
    ROOT.addEventListener('click', function (e) {
      var st = e.target.closest('[data-qstep]');
      if (st) { qty = Math.max(1, qty + Number(st.getAttribute('data-qstep'))); var qi=$('[data-qty-in]'); if(qi)qi.value=qty; render(); return; }
      if (e.target.closest('[data-mtp-add]')) { e.preventDefault(); addToCart(); }
    });

    function isTopHung() { return /top/i.test(hinge.hung); }
    // an offset must be a sensible number that fits inside the door
    function offOk(v) {
      if (v === '' || v === null || v === undefined) return false;
      var n = parseFloat(v);
      if (isNaN(n) || n < 0) return false;
      var lim = Math.max(parseFloat(dimH) || 0, parseFloat(dimW) || 0);
      return lim ? n <= lim : true;
    }
    function hingeComplete() {
      var minH = CFG.hingeMinH || 0;
      var hh = parseFloat(dimH);
      if (minH && hh > 0 && hh < minH) return false;
      if (!hinge.on) return false;
      return !!hinge.hung && !!hinge.handle && offOk(hinge.a) && offOk(hinge.b);
    }
    // charged as soon as drilling is requested; the button stays locked until complete
    function hingeFee() {
      var minH = CFG.hingeMinH || 0;
      var h = parseFloat(dimH);
      if (minH && h > 0 && h < minH) return 0;   // never charge for what we hid
      return hinge.on ? CFG.hingeFee : 0;
    }
    function offLabels() {
      return isTopHung() ? [CFG.offTop, CFG.offBottom] : [CFG.offRight, CFG.offLeft];
    }

    /* ===== render ===== */
    // let other blocks on the page know whether this is a made to measure order.
    // The delivery timeline listens for this, because the customer never picks
    // an (M2M) variant when ordering through this module.
    var lastAnnounced = null;
    function announce(isM2M) {
      if (isM2M === lastAnnounced) return;
      lastAnnounced = isM2M;
      try {
        document.dispatchEvent(new CustomEvent('mtp:quote', {
          bubbles: true,
          detail: { madeToMeasure: isM2M, product: PRODUCT.handle }
        }));
      } catch (e) {}
    }

    function render() {
      var h = parseFloat(dimH), w = parseFloat(dimW), q = quote(h, w);

      var valid = q && !q.over && h >= CFG.minDim && w >= CFG.minDim;
      announce(!!(valid && q.kind !== 'stock'));
      // Hinge drilling is not possible on very short doors, so the whole
      // section disappears rather than offering something we cannot make.
      var minH = CFG.hingeMinH || 0;
      var hingeOk = !minH || !(h > 0) || h >= minH;
      var block = $('[data-hinge-block]');
      if (block) block.hidden = !hingeOk;
      var na = $('[data-hinge-na]');
      if (na) na.hidden = hingeOk || !(h > 0);
      if (!hingeOk && hinge.on) {
        hinge = blankHinge();
        var cb = $('[data-hinge-on]');
        if (cb) cb.checked = false;
      }

      var det = $('[data-hinge-detail]'); if (det) det.hidden = !hinge.on;
      var L = offLabels();
      var la = $('[data-off-a-label]'), lb = $('[data-off-b-label]');
      if (la) la.textContent = L[0];
      if (lb) lb.textContent = L[1];
      var ow = $('[data-off-wrap]'); if (ow) ow.hidden = !hinge.hung;
      var hm = $('[data-hinge-msg]');
      if (hm) {
        var txt = '';
        if (hinge.on) {
          if (!hinge.hung) txt = 'Choose how the door is hung.';
          else if (!offOk(hinge.a) || !offOk(hinge.b)) txt = 'Enter both hinge measurements in ' + CFG.unit + '.';
          else if (!hinge.handle) txt = 'Choose the handle position.';
        }
        hm.hidden = !txt; hm.textContent = txt;
      }

      if (!dimH || !dimW || !q) { setState('empty', 'Enter a height and width for your price.'); syncBtn(); return; }
      if (q.over) {
        setState('warn', 'That size is outside this range (max ' + MAX_H + ' \u00d7 ' + MAX_W + ' ' + CFG.unit + '). Please contact us for a quote.');
        syncBtn(); return;
      }
      if (h < MIN_H || w < MIN_W) {
        setState('warn', 'The smallest we make is ' + MIN_H + ' ' + esc(CFG.unit) +
          ' high by ' + MIN_W + ' ' + esc(CFG.unit) + ' wide.');
        syncBtn(); return;
      }

      var hf = hingeFee(), each = q.price + hf;
      var lines = '';
      if (q.kind === 'stock') {
        lines = '<span class="mtp-price-tag">Stock size</span>';
      } else {
        // the markup percentage is internal, it must never appear on the storefront
        lines = '<span class="mtp-price-tag mtp-price-tag--made">Made to measure</span>' +
                (CFG.showBase
                  ? '<span class="mtp-price-from">from ' + esc(q.base.h + ' \u00d7 ' + q.base.w) + (q.est ? ' (estimated)' : '') + '</span>'
                  : '');
      }
      $('[data-quote]').setAttribute('data-state','ok');
      $('[data-price-amount]').innerHTML = money(each * qty) + (qty>1 ? ' <small>('+qty+' \u00d7 '+money(each)+')</small>' : '');
      $('[data-price-tags]').innerHTML = lines + (hf ? '<span class="mtp-price-tag">+ hinge ' + money(hf) + '</span>' : '');
      syncBtn();
    }
    function setState(state, text) {
      $('[data-quote]').setAttribute('data-state', state);
      var a = $('[data-price-amount]'), t = $('[data-price-tags]');
      if (a) a.textContent = '';
      if (t) t.innerHTML = '<span class="mtp-price-msg' + (state==='warn'?' mtp-price-msg--warn':'') + '">' + esc(text) + '</span>';
    }

    function currentQuote() {
      var h = parseFloat(dimH), w = parseFloat(dimW);
      if (!dimH || !dimW || h < MIN_H || w < MIN_W) return null;
      if (h > MAX_H || w > MAX_W) return null;
      var q = quote(h, w);
      return (q && q.over) ? null : q;
    }
    function syncBtn() {
      var q = currentQuote(), ready = !!q;
      var minHh = CFG.hingeMinH || 0, hcur = parseFloat(dimH);
      var hingeUsable = !minHh || !(hcur > 0) || hcur >= minHh;
      if (hinge.on && hingeUsable && !hingeComplete()) ready = false;
      var needConfirm = q && q.kind !== 'stock' && CFG.confirmText && CFG.confirmText !== 'confirm';
      var cw = $('[data-confirm-wrap]'); if (cw) cw.hidden = !needConfirm;
      if (needConfirm) { var c = $('[data-confirm]'); if (c && !c.checked) ready = false; }
      var btn = $('[data-mtp-add]'); if (btn) btn.disabled = !ready;
    }

    /* ===== cart refresh plumbing =====
       Shopify can return freshly rendered section HTML with the add request,
       which is how themes update their drawer without a reload. Swap those in,
       then fire the events themes listen for. */
    var SECTION_IDS = ['cart-drawer','cart-icon-bubble','cart-live-region-text','cart-notification',
      'cart-drawer-items','main-cart-items','main-cart-footer','mini-cart','cart'];

    function cartSections() {
      var found = [];
      SECTION_IDS.forEach(function (id) {
        if (document.getElementById(id) || document.getElementById('shopify-section-' + id) ||
            document.querySelector('[data-section-id="' + id + '"]')) found.push(id);
      });
      Array.prototype.forEach.call(document.querySelectorAll('[id^="shopify-section-"]'), function (el) {
        var id = el.id.replace('shopify-section-', '');
        if (/cart/i.test(id) && found.indexOf(id) === -1) found.push(id);
      });
      return found.slice(0, 6);
    }

    function applySections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var target = document.getElementById('shopify-section-' + id) || document.getElementById(id) ||
                     document.querySelector('[data-section-id="' + id + '"]');
        if (!target) return;
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id) || doc.getElementById(id) ||
                      doc.querySelector('[data-section-id="' + id + '"]') || doc.body;
          target.innerHTML = fresh.innerHTML;
        } catch (e) {}
      });
    }

    function fireCartEvents(cart) {
      // Hyper (Foxtheme) listens on these and reads event.detail.cart, crashing
      // if it is missing. So we always pass the fetched cart in the detail, in the
      // shapes different theme families expect.
      var names = ['cart:updated','cart:refresh','cart:change','cart:build','cart:added',
                   'ajaxProduct:added','product:added','cart-drawer:open','cart:open'];
      names.forEach(function (n) {
        try {
          document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } }));
        } catch (e) {}
      });
      try { document.dispatchEvent(new CustomEvent('mtp:added', { detail: { cart: cart } })); } catch (e) {}
    }

    function notifyTheme() {
      // fetch the real cart first so the theme's own handlers have what they need
      fetch((CFG.root || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { fireCartEvents(cart); })
        .catch(function () { fireCartEvents(null); });
    }

    function openDrawer() {
      if (!CFG.openDrawer) return;
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { try { d.open(); return; } catch (e) {} }
      var t = document.querySelector('[data-cart-drawer-toggle], .js-cart-drawer-open, #cart-icon-bubble');
      if (t && t.click) { try { t.click(); } catch (e) {} }
    }

    /* ===== cart ===== */
    function showErr(m){ var e=$('[data-mtp-err]'); if(!e)return; e.hidden=!m; e.textContent=m||''; }
    function addToCart() {
      var q = currentQuote(); if (!q) return;
      var hf = hingeFee();
      // without the charge product the basket would silently undercharge
      if ((q.markupFee > 0 || hf > 0) && !CFG.chargeVariantId) {
        showErr('Made to measure is not available right now. Please contact us to order this size.');
        return;
      }
      var h = parseFloat(dimH), w = parseFloat(dimW);
      var btn = $('[data-mtp-add]'), label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding\u2026'; showErr('');

      var sizeText = fmt(h) + ' \u00d7 ' + fmt(w) + ' ' + CFG.unit;
      var props = {};
      props[CFG.flagName] = CFG.flagValue;
      props[CFG.sizeLabel] = sizeText;
      // leading underscore: kept on the order for the workshop, hidden from the
      // customer in the cart and at checkout
      if (q.kind !== 'stock') props['_Priced from'] = q.base.h + ' \u00d7 ' + q.base.w;
      // an extrapolated quote is worth flagging to whoever picks the order,
      // since no stock size covers it and the workshop is cutting from a bar
      if (q.est) props['_Estimated'] = 'beyond stock grid';
      if (hinge.on) {
        var L2 = offLabels();
        props[CFG.hingeLabel] = hinge.hung;
        props[L2[0]] = fmt(parseFloat(hinge.a)) + ' ' + CFG.unit;
        props[L2[1]] = fmt(parseFloat(hinge.b)) + ' ' + CFG.unit;
        props[CFG.handleLabel] = hinge.handle;
      }

      // per-door pence, so the cart can keep the charge lines in step and show
      // each door its own price. Names start with _ so themes hide them.
      props['_mtpM'] = String(q.markupFee);
      props['_mtpH'] = String(hf);

      var items = [{ id: q.variantId, quantity: qty, properties: props }];
      if (q.markupFee > 0) {
        var fp = {}; fp[CFG.flagName] = CFG.flagValue; fp['For'] = PRODUCT.title + ' (' + sizeText + ')'; fp['_mtp'] = 'markup';
        items.push({ id: CFG.chargeVariantId, quantity: q.markupFee * qty, properties: fp });
      }
      if (hf > 0) {
        var hp = {}; hp[CFG.flagName] = CFG.flagValue; hp['For'] = PRODUCT.title + ' (' + sizeText + ')'; hp['_mtp'] = 'hinge';
        items.push({ id: CFG.chargeVariantId, quantity: hf * qty, properties: hp });
      }

      var payload = { items: items };
      var secs = cartSections();
      if (secs.length) { payload.sections = secs.join(','); payload.sections_url = window.location.pathname; }

      fetch(base + (CFG.cartAdd || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) { showErr((res.data && res.data.description) || 'Could not add to basket.'); btn.disabled=false; btn.textContent=label; return; }
          if (CFG.cartRedirect) { window.location.href = base + (CFG.cartUrl || '/cart'); return; }
          applySections(res.data && res.data.sections);
          notifyTheme();
          openDrawer();
          btn.textContent = 'Added \u2713';
          setTimeout(function(){ btn.textContent = label; btn.disabled = false; }, 1600);
        })
        .catch(function () { showErr('The basket did not respond. Try again.'); btn.disabled=false; btn.textContent=label; });
    }

    /* ===== open/close toggle ===== */
    function setOpen(on) {
      var panel = $('[data-mtp-panel]'), btn = $('[data-mtp-toggle]');
      if (!panel) return;
      panel.hidden = !on;
      ROOT.setAttribute('data-open', on ? 'true' : 'false');
      if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var f = $('[data-dim-h]'); if (f) setTimeout(function(){ f.focus(); }, 60); }
    }
    ROOT.addEventListener('click', function (e) {
      if (e.target.closest('[data-mtp-toggle]')) {
        e.preventDefault();
        setOpen(ROOT.getAttribute('data-open') !== 'true');
      }
      if (e.target.closest('[data-mtp-cancel]')) { e.preventDefault(); setOpen(false); }
    });

    /* ===== shortcode relocation =====
       If [made-to-order] appears anywhere on the page (product description, a
       rich text block, a metafield), move the module there. Lets it be placed
       without editing theme files. */
    function relocate() {
      var token = CFG.shortcode || '[made-to-order]';
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var hit = null, node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.indexOf(token) > -1) {
          if (ROOT.contains(node)) continue;
          hit = node; break;
        }
      }
      if (!hit) return;
      var host = document.createElement('div');
      var parts = hit.nodeValue.split(token);
      hit.nodeValue = parts[0];
      hit.parentNode.insertBefore(host, hit.nextSibling);
      if (parts.length > 1 && parts[1]) {
        host.parentNode.insertBefore(document.createTextNode(parts.slice(1).join(token)), host.nextSibling);
      }
      host.appendChild(ROOT);
    }

    /* ===== colour watcher =====
       Rebuild the size index whenever the customer switches colour, so the
       quote, the stated range and the variant we add all follow the selection. */
    var curGroup = null;
    function syncGroup() {
      var g = selectedGroup();
      if (g === curGroup) return;
      curGroup = g;
      buildIndex(g);
      ROOT.hidden = !sized.length;          // this colour has no sized variants
      if (!sized.length) return;
      var rn = $('[data-range-note]');
      if (rn) {
        // what we will CUT, not what we stock, so this matches what the
        // customer is actually allowed to order
        rn.textContent = 'Made from ' + MIN_H + ' to ' + MAX_H + ' ' + CFG.unit + ' high, ' +
                         MIN_W + ' to ' + MAX_W + ' ' + CFG.unit + ' wide.';
      }
      render();
    }

    /* ===== boot ===== */
    relocate();
    setOpen(!!CFG.startOpen);
    syncGroup();
    // themes swap the variant in different ways, so watch for all of them
    document.addEventListener('change', function () { setTimeout(syncGroup, 60); }, true);
    ['variant:change','variantChange','product:variant-change','on:variant:change','variant_change']
      .forEach(function (n) { document.addEventListener(n, function () { setTimeout(syncGroup, 60); }); });
    setInterval(syncGroup, 500);
  }
})();